const agencySelect = document.querySelector('[js-agencies-select]');

const redirect = (goto) => {
    if (goto != '') {
        window.location = goto;
    }
}

if (agencySelect) {
    agencySelect.onchange = function(){
        let targetAgency = this.value;
        redirect(targetAgency);
    };
}
